import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '../store/featureFlags';
import { RecurringMonthlyExtensionsEnabled } from './types';

export const useRecurringMonthlyExtensionsEnabled = () => {
  const recurringMonthlyExtensionFiEnabled = useSelector(selectFeatureFlags).FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_FI_ENABLED;
  const recurringMonthlyExtensionNoEnabled = useSelector(selectFeatureFlags).FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_NO_ENABLED;
  const recurringMonthlyExtensionSeEnabled = useSelector(selectFeatureFlags).FEATURE_FLAG_RECURRING_MONTHLY_EXTENSION_SE_ENABLED;

  return {
    recurringMonthlyExtensionFiEnabled,
    recurringMonthlyExtensionNoEnabled,
    recurringMonthlyExtensionSeEnabled,
  };
};

export const isRecurringMonthlyExtensionEnabled = (
  country: string | undefined,
  { recurringMonthlyExtensionFiEnabled, recurringMonthlyExtensionNoEnabled, recurringMonthlyExtensionSeEnabled }: RecurringMonthlyExtensionsEnabled,
) => {
  switch (country) {
    case 'FI':
      return recurringMonthlyExtensionFiEnabled;
    case 'NO':
      return recurringMonthlyExtensionNoEnabled;
    case 'SE':
      return recurringMonthlyExtensionSeEnabled;
    default:
      return true;
  }
};
